export default {
    namespaced: true,
    state:{
        settings: [],
        settingCreate: {
            modal: false,
            values: {},
            globalKeys: [],
            dayOfMonthKeys: [],
            yearRequiredKeys: []
        },
        settingEdit: {
            modal: false,
            values: {},
            globalKeys: [],
            dayOfMonthKeys: [],
            yearRequiredKeys: []
        }
    },
    getters:{
        settings(state){
            return state.settings;
        },
        settingCreate(state) {
            return state.settingCreate
        },
        settingEdit(state) {
            return state.settingEdit
        }
    },
    mutations:{
        SET_SETTINGS(state, values){
            state.settings = values;
        },
        SET_SETTING_CREATE_MODAL(state, value) {
            state.settingCreate.modal = value
        },
        SET_SETTING_CREATE_VALUES(state, value) {
            state.settingCreate.values = value
            state.settingCreate.globalKeys = value.globalKeys || []
            state.settingCreate.dayOfMonthKeys = value.dayOfMonthKeys || []
            state.settingCreate.yearRequiredKeys = value.yearRequiredKeys || []
        },
        SET_SETTING_EDIT_MODAL(state, value) {
            state.settingEdit.modal = value
        },
        SET_SETTING_EDIT_VALUES(state, value) {
            state.settingEdit.values = value
            state.settingEdit.globalKeys = value.globalKeys || []
            state.settingEdit.dayOfMonthKeys = value.dayOfMonthKeys || []
            state.settingEdit.yearRequiredKeys = value.yearRequiredKeys || []
        },
        PUSH_SETTING(state, value){
            state.settings.push(value);
        },
        SET_UPDATE_SETTING(state, values){
            var editedIndex = state.settings.map(setting => setting.id).indexOf(values.id)
            if (editedIndex > -1){
                Object.assign(state.settings[editedIndex], values)
            }
            return;
        },
        SPLICE_SETTING(state, value){
            let i = state.settings.map(setting => setting.id).indexOf(value)
            state.settings.splice(i, 1)
        }
    },
    actions:{
        getSettings({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('admin/settings').then((response) => {
                    commit('SET_SETTINGS', response.data.data)
                    resolve(response)
                })
                    .catch((error) => {
                        reject(error)
                    })
            });
        },
        settingCreate({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('admin/settings/create').then((response) =>{
                    commit('SET_SETTING_CREATE_VALUES', response.data.data)
                    commit('SET_SETTING_CREATE_MODAL', true)
                    resolve(response)
                })
                    .catch((error) => {
                        reject(error)
                    })
            });
        },
        settingStore({commit, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.post('admin/settings', payload).then((response) => {
                    return dispatch('getSettings').then(() => {
                        resolve(response)
                    })
                })
                    .catch((error) => {
                        reject(error)
                    })
            });
        },
        settingEdit({ commit }, value) {
            return new Promise((resolve, reject) => {
                axios.get('admin/settings/' + value + '/edit').then((response) =>{
                    commit('SET_SETTING_EDIT_VALUES', response.data.data)
                    commit('SET_SETTING_EDIT_MODAL', true)
                    resolve(response)
                })
                    .catch((error) => {
                        reject(error)
                    })
            });
        },
        settingUpdate({commit, dispatch}, payload) {
            var value = payload.id;
            return new Promise((resolve, reject) => {
                axios.put('admin/settings/' + value, payload).then((response) => {
                    return dispatch('getSettings').then(() => {
                        resolve(response)
                    })
                })
                    .catch((error) => {
                        reject(error)
                    })
            });
        },
        deleteSetting({ commit }, value) {
            return new Promise((resolve, reject) => {
                axios.delete('admin/settings/' + value).then((response) => {
                    commit('SPLICE_SETTING', value);
                    resolve(response)
                })
                    .catch((error) => {
                        reject(error)
                    })
            });
        }
    }
}